import MiniQForm from "./MiniQForm";
import MiniQ2Form from "./MiniQ2Form";
import { useEffect, useState } from "react";

const ManagerSensorsForm = ({ item, setItem, model }) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(model);
    }, [model])

    const renderFormByModel = () => {
        switch (value) {
            case "MQ-SX":
                return <MiniQForm item={item} setItem={setItem} />;
            case "MQ2-4G":
                return <MiniQ2Form item={item} setItem={setItem} />;
            default:
                return <></>;
        }
    };


    return renderFormByModel();

}
export default ManagerSensorsForm;